module.exports = __webpack_public_path__ + "img/link-1.234d794e.jpg";